"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.catchPromiseError = catchPromiseError;
exports.getPromiseErrorCatcher = getPromiseErrorCatcher;
var _logger = require("@ori/logger");
/**
 * @param packageName Package name used for key in AppInsights. It should be the same as the package name in package.json.
 * @returns Logging promise error function.
 */
function getPromiseErrorCatcher(packageName) {
  return async (promise, description) => catchPromiseError(promise, description, packageName);
}
async function catchPromiseError(promise, description, packageName) {
  const logger = new _logger.Logger(packageName);
  promise.catch(error => {
    logger.error(error, {
      action: 'catchPromiseError',
      description
    });
  });
  return promise;
}
